import * as i0 from '@angular/core';
import { ElementRef, Directive, Inject, Output, NgModule } from '@angular/core';
import { tuiDragAndDropFrom, TuiDragStage } from '@taiga-ui/cdk/observables';
import { filter, map } from 'rxjs/operators';

/**
 * @deprecated not used anywhere
 */
class TuiDragDirective {
    constructor(el) {
        this.el = el;
        this.dragAndDropFrom$ = tuiDragAndDropFrom(this.el.nativeElement);
        this.start = this.dragAndDropFrom$.pipe(filter(({ stage }) => stage === TuiDragStage.Start), map(({ event }) => event));
        this.continues = this.dragAndDropFrom$.pipe(filter(({ stage }) => stage === TuiDragStage.Continues), map(({ event }) => event));
        this.end = this.dragAndDropFrom$.pipe(filter(({ stage }) => stage === TuiDragStage.End), map(({ event }) => event));
    }
}
TuiDragDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDragDirective, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
TuiDragDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiDragDirective, selector: "[tuiDragStart], [tuiDragContinues], [tuiDragEnd]", outputs: { start: "tuiDragStart", continues: "tuiDragContinues", end: "tuiDragEnd" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDragDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tuiDragStart], [tuiDragContinues], [tuiDragEnd]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef, decorators: [{
                    type: Inject,
                    args: [ElementRef]
                }] }]; }, propDecorators: { start: [{
                type: Output,
                args: ['tuiDragStart']
            }], continues: [{
                type: Output,
                args: ['tuiDragContinues']
            }], end: [{
                type: Output,
                args: ['tuiDragEnd']
            }] } });

/**
 * @deprecated not used anywhere
 */
class TuiDragModule {
}
TuiDragModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDragModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiDragModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDragModule, declarations: [TuiDragDirective], exports: [TuiDragDirective] });
TuiDragModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDragModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDragModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiDragDirective],
                    exports: [TuiDragDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDragDirective, TuiDragModule };
